import { useMutation } from "@tanstack/react-query";
import { apiRequest, type ApiError } from "@/shared/api";

export type ForgotPasswordPayload = {
  email: string;
};

export type ResetPasswordPayload = {
  password: string;
  token: string;
};

export const forgotPassword = (payload: ForgotPasswordPayload) =>
  apiRequest<void>({
    url: "/auth/forgot-password",
    method: "post",
    data: payload,
  });

export const resetPassword = (payload: ResetPasswordPayload) =>
  apiRequest<void>({
    url: "/auth/reset-password",
    method: "post",
    data: payload,
  });

export const useForgotPassword = () =>
  useMutation<void, ApiError, ForgotPasswordPayload>({
    mutationFn: forgotPassword,
  });

export const useResetPassword = () =>
  useMutation<void, ApiError, ResetPasswordPayload>({
    mutationFn: resetPassword,
  });
